import React from 'react';
import { ReachScore } from '../../../services/reachService';

const LABELS: Record<ReachScore, string> = {
  1: 'Not yet',
  2: 'Emerging',
  3: 'Established',
  4: 'Embedded',
};

const ACTIVE_CLASSES: Record<ReachScore, string> = {
  1: 'bg-red-500 text-white border-red-500',
  2: 'bg-amber-400 text-white border-amber-400',
  3: 'bg-blue-500 text-white border-blue-500',
  4: 'bg-green-500 text-white border-green-500',
};

const DOT_CLASSES: Record<ReachScore, string> = {
  1: 'bg-red-500',
  2: 'bg-amber-400',
  3: 'bg-blue-500',
  4: 'bg-green-500',
};

interface Props {
  value: ReachScore | null | undefined;
  onChange: (v: ReachScore) => void;
  disabled?: boolean;
  showLegend?: boolean;
}

export const REACHScoreInput: React.FC<Props> = ({ value, onChange, disabled, showLegend }) => (
  <div className="flex flex-col gap-1.5">
    <div className="flex gap-1">
      {([1, 2, 3, 4] as ReachScore[]).map((score) => (
        <button
          key={score}
          type="button"
          disabled={disabled}
          onClick={() => onChange(score)}
          title={LABELS[score]}
          className={`w-9 h-8 rounded text-xs font-bold transition-all border flex items-center justify-center ${
            value === score
              ? ACTIVE_CLASSES[score]
              : 'bg-slate-100 text-slate-400 border-transparent hover:bg-slate-200'
          }`}
        >
          {score}
        </button>
      ))}
    </div>
    {showLegend && (
      <div className="flex gap-2 flex-wrap">
        {([1, 2, 3, 4] as ReachScore[]).map(score => (
          <div key={score} className="flex items-center gap-1">
            <span className={`w-2 h-2 rounded-sm flex-shrink-0 ${DOT_CLASSES[score]}`} />
            <span className="text-[10px] text-slate-400">{score} {LABELS[score]}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);
